import React, { FC } from 'react';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';

import type { BettingContextProps } from '../../../../types';
import type { ReduxState } from 'app/redux/types';

import { withinBettingContext } from 'app/contexts/betting';
import { isFFPrematchWS } from 'app/lib/site-configs/selectors';
import { BettingPresentationSelectors } from 'app/redux/betting-presentation/grid/selectors';

import InnerLine from './components/InnerLine';

// ---

type InnerLineContainerProps = {
  matchId: number;
};

type StoreProps = {
  innerLineListWithNoEmptyLines: ReturnType<BettingPresentationSelectors['innerLineListWithNoEmptyLinesSelector']>;
};

const InnerLineContainer: FC<InnerLineContainerProps & StoreProps> = ({
  innerLineListWithNoEmptyLines,
}) => {
  return (
    <>
      {innerLineListWithNoEmptyLines.size && (
        innerLineListWithNoEmptyLines.map((line) => {
          return line.id && (
            <InnerLine
              key={line.id}
              id={line.id}
              names={line.names}
              kind={line.kind}
              matchId={line.matchId}
              autoExpand={innerLineListWithNoEmptyLines.size === 1} />
          );
        })
      )}
    </>
  );
};

const mapStateToProps = (
  state: ReduxState,
  {
    $betting: {
      grid: {
        selectors: {
          innerLineListWithNoEmptyLinesSelector,
        },
      },
      matchGrid,
    },
    matchId,
  }: BettingContextProps & InnerLineContainerProps,
): StoreProps => {
  const isPrematchWS = isFFPrematchWS(state);
  const innerLineNoEmptyWSSelector = matchGrid?.selectors?.innerLineListWithNoEmptyLinesSelector;

  const innerLineListWithNoEmptyLines = (isPrematchWS && innerLineNoEmptyWSSelector)
    ? innerLineNoEmptyWSSelector(state, matchId)
    : innerLineListWithNoEmptyLinesSelector(state, matchId);

  return {
    innerLineListWithNoEmptyLines,
  };
};

export default compose<FC<InnerLineContainerProps>>(
  withinBettingContext,
  connect(mapStateToProps),
)(InnerLineContainer);
